//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'page-navbar',

  data() {
    return {
      selected: '1'
    };
  }
};



// WEBPACK FOOTER //
// ./example/pages/navbar.vue